import camelcaseKeys from 'camelcase-keys'
export class Slot {
  constructor (params = {}) {
    const { availableSlots, excludedSlots } = params ? camelcaseKeys(params) : {}
    this.availableSlots = availableSlots || []
    this.excludedSlots = excludedSlots || []
  }
}
